import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
    details: {

    },
    certificateDetails: {

    }
}

export const getReferralDetails = createAsyncThunk(
    'getReferralDetails',
    async({ id }) => {
        try {
            const response = await axios.get(`https://xgfy-czuw-092q.m2.xano.io/api:CjB-KpD3/referral/referrer_details?referral_id=${id}`)
            return response.data?.data
        } catch (error) {
            throw error
        }
    }
)

export const getCertificateDetailsFromMongo = createAsyncThunk(
    'getCertificateDetailsFromMongo',
    async({ unique_certificate_id }) => {
        try {
            const response = await axios.post(`https://certified-new.learntube.ai/verify_certificate`, {
                unique_certificate_id
            })
            return response.data?.data
        } catch (error) {
            throw error
        }
    }
)

export const getCertificateDetailsFromXano = createAsyncThunk(
    'getCertificateDetailsFromXano',
    async({ unique_certificate_id }) => {
        try {
            const response = await axios.get(`https://xgfy-czuw-092q.m2.xano.io/api:certificate/validate`,{
                params: {
                    validation_method: 'unique_certificate_id',
                    unique_certificate_id
                }
            })
            return response.data?.data
        } catch (error) {
            throw error
        }
    }
)

const referralDetailsSlice = createSlice({
    name: 'referralDetails',
    initialState,
    reducers: {
        resetReferallIdData: (state, action) => {
            state.details = {}
            state.certificateDetails = {}
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getReferralDetails.fulfilled, (state, action) => {
                state.certificateDetails = {}
                state.details = action.payload
            })
            .addCase(getCertificateDetailsFromXano.fulfilled, (state, action) => {
                state.details = {}
                state.certificateDetails = action.payload
            })
            .addCase(getCertificateDetailsFromMongo.fulfilled, (state, action) => {
                state.details = {}
                state.certificateDetails = action.payload
            })
    }
})

export const { resetReferallIdData } = referralDetailsSlice.actions
export const selectCertificateDetailsData = (state) => state.referralDetails?.certificateDetails
export const selectReferralData = (state) => state.referralDetails?.details
export default referralDetailsSlice.reducer